/* GOPSHOP 7.9 – animierter Rauch-Hintergrund für den ganzen Shop (heller Modus).
   WebGL-Shader in niedriger Auflösung (weich hochskaliert), max. 30 Bilder/s, pausiert bei verstecktem Tab,
   während ein Spiel läuft/sichtbar ist und bei „Weniger Bewegung“ (dann ein Standbild). Ohne WebGL bleiben die CSS-Farbwolken. */
(function () {
  var host = document.querySelector('.gop-lg-bg');
  if (!host || !document.documentElement.classList.contains('gop-light')) return;
  if (getComputedStyle(host).display === 'none') return;

  var FRAG = [
    'precision mediump float;',
    'uniform vec2 r; uniform float t;',
    'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
    'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);',
    ' return mix(mix(h(i),h(i+vec2(1.,0.)),f.x),mix(h(i+vec2(0.,1.)),h(i+1.),f.x),f.y);}',
    'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<4;i++){v+=a*n(p);p=p*2.02+vec2(1.7,9.2);a*=.5;}return v;}',
    'void main(){',
    ' vec2 p=(gl_FragCoord.xy-.5*r)/r.y*1.35;',
    ' float T=t*.045;',
    ' vec2 q=vec2(fbm(p*1.2+vec2(T,-T*.7)),fbm(p*1.2+vec2(5.2-T*.6,1.3+T)));',
    ' vec2 w=vec2(fbm(p*1.9+q*3.+vec2(1.7,9.2)+T*1.1),fbm(p*1.9+q*3.+vec2(8.3,2.8)-T*.9));',
    ' float f=fbm(p*2.2+w*3.2-vec2(T*.5,T*.3));',
    ' vec3 base=vec3(.958,.958,.97);',
    ' vec3 mint=vec3(.20,.95,.84), sky=vec3(.36,.64,1.), lil=vec3(.72,.54,1.), rose=vec3(1.,.66,.86);',
    ' vec3 tint=mix(mint,sky,smoothstep(.3,.75,w.x));',
    ' tint=mix(tint,lil,smoothstep(.45,.85,q.y));',
    ' tint=mix(tint,rose,smoothstep(.62,.95,w.y)*.55);',
    ' float k1=.5+.5*sin(t*.05), k2=.5+.5*sin(t*.037+2.1);',
    ' tint=mix(tint,vec3(1.,.74,.55),k1*smoothstep(.4,.9,w.y)*.45);',
    ' tint=mix(tint,vec3(.45,.9,.6),k2*smoothstep(.35,.85,q.x)*.35);',
    ' float wisp=smoothstep(.42,.95,f)*(.55+.45*smoothstep(.3,.8,q.x));',
    ' vec3 c=mix(base,tint,wisp*.55);',
    ' float hi=smoothstep(.58,1.,fbm(p*3.2+w*2.-T*1.4));',
    ' c=mix(c,vec3(1.),hi*.5);',
    ' c-=vec3(.02,.015,.0)*smoothstep(.5,.9,q.x*w.y*2.);',
    ' gl_FragColor=vec4(c,1.);',
    '}'
  ].join('\n');
  var VERT = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';

  var cv = document.createElement('canvas');
  cv.className = 'gop-lg-bg__smoke';
  cv.setAttribute('aria-hidden', 'true');
  var gl = cv.getContext('webgl', { antialias: false, alpha: false, depth: false, stencil: false, powerPreference: 'low-power', preserveDrawingBuffer: false });
  if (!gl) return;
  function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null; }
  var vs = sh(gl.VERTEX_SHADER, VERT), fs = sh(gl.FRAGMENT_SHADER, FRAG);
  if (!vs || !fs) return;
  var pr = gl.createProgram(); gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
  if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return;
  gl.useProgram(pr);
  var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(pr, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  var uR = gl.getUniformLocation(pr, 'r'), uT = gl.getUniformLocation(pr, 't');

  host.insertBefore(cv, host.firstChild);
  host.classList.add('is-smoke');

  function size() {
    var w = window.innerWidth, h = window.innerHeight, k = Math.min(0.34, 460 / Math.max(w, 1));
    cv.width = Math.max(64, Math.round(w * k)); cv.height = Math.max(64, Math.round(h * k));
    gl.viewport(0, 0, cv.width, cv.height);
  }
  size();
  var rt = 0; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { size(); draw(performance.now()); }, 200); }, { passive: true });

  var t0 = performance.now() - Math.random() * 60000, last = 0, raf = 0;
  function draw(now) { gl.uniform2f(uR, cv.width, cv.height); gl.uniform1f(uT, (now - t0) / 1000); gl.drawArrays(gl.TRIANGLES, 0, 3); }

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { draw(performance.now()); return; }

  /* Spiele haben Vorrang: pausieren, solange ein Spiel sichtbar ist oder läuft */
  var gameVis = 0;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.__gv = e.intersectionRatio >= 0.35; }); gameVis = 0; games.forEach(function (g) { if (g.__gv) gameVis++; }); }, { threshold: [0, 0.35, 0.6] });
    var games = Array.prototype.slice.call(document.querySelectorAll('.gsp, .section-gop-game, .gop-game'));
    games.forEach(function (g) { io.observe(g); });
  }
  var bAt = 0, bVal = false, gem = null;
  function busy(now) {
    if (now - bAt < 400) return bVal; /* höchstens 2–3× pro Sekunde prüfen */
    bAt = now;
    var de = document.documentElement;
    gem = gem || document.querySelector('[data-gem-overlay]');
    bVal = document.hidden || gameVis > 0 || !de.classList.contains('gop-light') || de.classList.contains('gop-game-playing') || de.classList.contains('gop-flow-on') || !!(gem && !gem.hidden);
    return bVal;
  }
  function loop(now) {
    raf = requestAnimationFrame(loop);
    if (now - last < 33 || busy(now)) return;
    last = now;
    draw(now);
  }
  draw(performance.now());
  raf = requestAnimationFrame(loop);
  cv.addEventListener('webglcontextlost', function (e) { e.preventDefault(); cancelAnimationFrame(raf); host.classList.remove('is-smoke'); cv.remove(); });
})();
